// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"538":"19685846a13f65c9","4445":"f45795a83a7ff2d8"}[chunkId] + ".css";
};